// src/services/diagnosisService.js
import apiClient from "./apiClient";

const API_URL = `/medicinesinventory`; // Use relative path since apiClient has baseURL
  
export const createMedicine = async (invoice) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.post(API_URL, invoice);
    return response.data;
  } catch (error) {
    console.error("Error creating medicine:", error);
    throw error;
  }
};

export const getMedicineList = async () => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(API_URL);
    return response.data;
  } catch (error) {
    // Handle case where organization-specific table doesn't exist yet
    if (error.response?.status === 500 && 
        (error.response?.data?.message?.includes("Failed to retrieve") ||
         error.response?.data?.message?.includes("from table") ||
         error.response?.data?.message?.includes("does not exist"))) {
      console.warn("Organization-specific table not found, returning empty array:", error.response.data.message);
      return []; // Return empty array if table doesn't exist
    }
    console.error("Error fetching medicine:", error);
    throw error;
  }
};
